/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {WorkflowScriptPageOf, WorkflowScriptPageOfFromJSON, WorkflowScriptPageOfToJSON,} from './WorkflowScriptPageOf';

/**
 *
 * @export
 * @interface WorkflowScriptPageOfApiResult
 */
export interface WorkflowScriptPageOfApiResult {
    /**
     *
     * @type {boolean}
     * @memberof WorkflowScriptPageOfApiResult
     */
    success?: boolean;
    /**
     *
     * @type {WorkflowScriptPageOf}
     * @memberof WorkflowScriptPageOfApiResult
     */
    content?: WorkflowScriptPageOf;
    /**
     *
     * @type {string}
     * @memberof WorkflowScriptPageOfApiResult
     */
    message?: string | null;
}

export function WorkflowScriptPageOfApiResultFromJSON(json: any): WorkflowScriptPageOfApiResult {
    return WorkflowScriptPageOfApiResultFromJSONTyped(json, false);
}

export function WorkflowScriptPageOfApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowScriptPageOfApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : WorkflowScriptPageOfFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WorkflowScriptPageOfApiResultToJSON(value?: WorkflowScriptPageOfApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': WorkflowScriptPageOfToJSON(value.content),
        'message': value.message,
    };
}

